import PropTypes from "prop-types";

import Box from "@mui/material/Box";

const panelSx = {
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  flexDirection: "column",
  overflow: "hidden",
};

/** Tab body that stays mounted when hidden so switching tabs does not remount content. */
export function KeepMountedTabPanels({ children, sx }) {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

KeepMountedTabPanels.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default function KeepMountedTabPanel({
  active,
  children,
  name,
  mount = true,
  sx,
}) {
  if (!mount) {
    return null;
  }

  return (
    <Box
      role="tabpanel"
      id={name ? `tabpanel-${name}` : undefined}
      aria-hidden={!active}
      hidden={!active}
      sx={{
        ...panelSx,
        display: active ? "flex" : "none",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

KeepMountedTabPanel.propTypes = {
  active: PropTypes.bool.isRequired,
  children: PropTypes.node,
  name: PropTypes.string,
  mount: PropTypes.bool,
  sx: PropTypes.object,
};
